import { h } from '@atomify/jsx';

interface HoneypotProps {
    classes?: string;
    name: string;
    id: string;
}

export const Honeypot = ({ classes, name, id }: HoneypotProps) => {
    return (
        <div class={`u-sr-only ${classes}`}>
            <input id={id} name={name} type="text" autocomplete="off" tabindex="-1" />
        </div>
    );
};
